<template>
  <transition name="fade">
  <div class="maskTips" @click="hide" v-if="showmask">
    <div class="curTips">
      <el-image :src="point" fit="contain"></el-image>
      <p>双击</p>
      <p>放大/独立显示</p>
    </div>
  </div>
  </transition>
</template>

<script>
import point from "@/assets/images/point.svg"
export default {
  name: 'maskTips',
  props: { },
  data(){
    return{
      point,
       showmask:false,
       path:''
    }
  },
  watch:{
    $route:{
      handler(newv,oldv){
        if(newv && this.path && this.path == newv.name){
          this.isShowMask()
        }
      },immediate:true
    }
  },
  mounted() {
    this.path = this.$route.name;
    this.isShowMask()
    // this.autoDis()
  },
methods:{
  isShowMask(){
    this.times = localStorage.getItem(this.path+'-show')
    console.log('times: ', this.times, this.path+'-show')
    if(!this.times ||  this.times < 3){
      this.showmask= true;
      if(!this.times){this.times = 0}
    }else{
      this.showmask = false
    }
  },
  hide(){
    this.showmask = false
    this.setStorage()
  },
  autoDis(){
    setTimeout(() => {
      this.showmask = false
      this.setStorage()
    }, 5000);
  },

  setStorage(){
    localStorage.setItem(this.path+'-show',JSON.stringify(parseInt(this.times )+ 1))
    console.log(this.path+'-show');
  }
},
}
</script>
<style scoped lang="scss">
  .maskTips{
    width: 100vw;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 100;
    top: 0;
    left:0;
    .curTips{
      text-align: center;
      font-size: 16px;
      line-height: 1.8;
      color: #fff;
    }
  }

</style>